import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-logo-small',
  template: `<svg width="50" height="50" class="-left-3.5 relative" viewBox="0 0 40 58" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_18226_396705)">
  <path d="M16.0777 10.5455H11.0205V39.294H16.0777V10.5455Z" fill="white"/>
  <path d="M23.1507 39.294L16.6895 30.3587L23.518 19.4604H29.4241L22.6119 30.2289L29.9997 39.294H23.1507Z" fill="white"/>
  <path d="M28.9794 11.2877H23.959V16.2765H28.9794V11.2877Z" fill="#24DD8D"/>
  </g>
  <defs>
  <clipPath id="clip0_18226_396705">
  <rect width="40" height="58" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  `,
})
export class LogoSmallComponent {
  @Input() color: string = 'currentColor';
}
